export interface TurkeyProduct {
  id: string;
  name: string;
  samplePrice: number;
  bulkPrice: number;
  moq: number;
  image: string;
  category: string;
}

export interface TurkeyFactory {
  id: string;
  name: string;
  city: string;
  established: number;
  employees: string;
  verified: boolean;
  dropshipping: boolean;
  warehouseCountries?: string[];
  rating: number;
  responseRate: string;
  onTimeDelivery: string;
  productCount: number;
  categories: string[];
  description: string;
  logo: string;
  coverImage: string;
  products: TurkeyProduct[];
}

export const turkeyFactories: TurkeyFactory[] = [
  {
    id: "tf1",
    name: "Istanbul Textile & Denim Co.",
    city: "Istanbul",
    established: 2005,
    employees: "500–1000",
    verified: true,
    dropshipping: true,
    warehouseCountries: ["Turkey", "UAE", "Saudi Arabia", "UK", "Germany", "USA", "France"],
    rating: 4.9,
    responseRate: "98%",
    onTimeDelivery: "97%",
    productCount: 2400,
    categories: ["Textiles", "Denim", "Fashion"],
    description: "Turkey's premier denim and textile manufacturer based in Istanbul. Producing premium denim jeans, jackets, and fashion apparel for global brands and retailers with full private label and dropshipping support.",
    logo: "https://public.readdy.ai/ai/img_res/32dbeba46120766da3b4da0d2c6d3283.jpg",
    coverImage: "https://readdy.ai/api/search-image?query=Istanbul%20Turkey%20modern%20textile%20denim%20factory%20production%20line%20workers%20fashion%20apparel%20professional%20bright%20clean%20interior&width=800&height=400&seq=tfc1&orientation=landscape",
    products: [
      {
        id: "tf1p1",
        name: "Premium Slim Fit Denim Jeans",
        samplePrice: 38,
        bulkPrice: 12,
        moq: 50,
        category: "Denim",
        image: "https://readdy.ai/api/search-image?query=premium%20slim%20fit%20denim%20jeans%20modern%20fashion%20white%20background%20product%20photography%20professional%20clean%20clothing%20Turkey&width=400&height=400&seq=tf1p1&orientation=squarish",
      },
      {
        id: "tf1p2",
        name: "Denim Jacket Oversized Unisex",
        samplePrice: 55,
        bulkPrice: 18,
        moq: 30,
        category: "Denim",
        image: "https://readdy.ai/api/search-image?query=denim%20jacket%20oversized%20unisex%20modern%20fashion%20white%20background%20product%20photography%20professional%20clean%20clothing%20Turkey&width=400&height=400&seq=tf1p2&orientation=squarish",
      },
      {
        id: "tf1p3",
        name: "Cotton Fabric Roll 100m (Premium)",
        samplePrice: 120,
        bulkPrice: 45,
        moq: 10,
        category: "Textiles",
        image: "https://readdy.ai/api/search-image?query=cotton%20fabric%20roll%20100m%20premium%20textile%20material%20white%20background%20product%20photography%20professional%20clean%20manufacturing%20Turkey&width=400&height=400&seq=tf1p3&orientation=squarish",
      },
    ],
  },
  {
    id: "tf2",
    name: "Bursa Silk & Luxury Fabrics",
    city: "Bursa",
    established: 2001,
    employees: "200–500",
    verified: true,
    dropshipping: true,
    warehouseCountries: ["Turkey", "UAE", "Saudi Arabia", "UK", "Italy", "France", "Japan"],
    rating: 4.9,
    responseRate: "97%",
    onTimeDelivery: "96%",
    productCount: 1180,
    categories: ["Silk", "Luxury Fabrics", "Home Textiles"],
    description: "Historic silk and luxury fabric manufacturer from Bursa — Turkey's ancient silk capital. Producing world-renowned Turkish silk, velvet, and luxury home textiles for global fashion houses and interior designers.",
    logo: "https://readdy.ai/api/search-image?query=luxury%20silk%20fabric%20company%20logo%20gold%20silk%20thread%20emblem%20white%20background%20Bursa%20Turkey%20corporate%20identity%20elegant%20minimalist&width=80&height=80&seq=tfl2&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Bursa%20Turkey%20silk%20luxury%20fabric%20factory%20production%20weaving%20looms%20workers%20professional%20bright%20elegant%20interior%20historic&width=800&height=400&seq=tfc2&orientation=landscape",
    products: [
      {
        id: "tf2p1",
        name: "Pure Turkish Silk Fabric 5m",
        samplePrice: 180,
        bulkPrice: 68,
        moq: 10,
        category: "Silk",
        image: "https://readdy.ai/api/search-image?query=pure%20Turkish%20silk%20fabric%205m%20luxury%20elegant%20shimmering%20white%20background%20product%20photography%20premium%20textile%20Bursa&width=400&height=400&seq=tf2p1&orientation=squarish",
      },
      {
        id: "tf2p2",
        name: "Ottoman Velvet Upholstery Roll 10m",
        samplePrice: 220,
        bulkPrice: 85,
        moq: 5,
        category: "Luxury Fabrics",
        image: "https://readdy.ai/api/search-image?query=Ottoman%20velvet%20upholstery%20roll%2010m%20luxury%20rich%20fabric%20white%20background%20product%20photography%20premium%20textile%20Turkey&width=400&height=400&seq=tf2p2&orientation=squarish",
      },
      {
        id: "tf2p3",
        name: "Turkish Silk Scarf Collection (12pcs)",
        samplePrice: 95,
        bulkPrice: 35,
        moq: 12,
        category: "Silk",
        image: "https://readdy.ai/api/search-image?query=Turkish%20silk%20scarf%20collection%2012pcs%20luxury%20elegant%20colorful%20white%20background%20product%20photography%20premium%20fashion&width=400&height=400&seq=tf2p3&orientation=squarish",
      },
    ],
  },
  {
    id: "tf3",
    name: "Ankara Ceramic & Tile Works",
    city: "Ankara",
    established: 2007,
    employees: "200–500",
    verified: true,
    dropshipping: false,
    rating: 4.8,
    responseRate: "94%",
    onTimeDelivery: "93%",
    productCount: 920,
    categories: ["Ceramics", "Tiles", "Home Decor"],
    description: "Premium Turkish ceramic and tile manufacturer in Ankara. Producing hand-painted Iznik-style tiles, luxury bathroom ceramics, and decorative home pieces exported to over 40 countries worldwide.",
    logo: "https://readdy.ai/api/search-image?query=ceramic%20tile%20company%20logo%20gold%20geometric%20pattern%20emblem%20white%20background%20Ankara%20Turkey%20corporate%20identity%20elegant%20minimalist&width=80&height=80&seq=tfl3&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Ankara%20Turkey%20ceramic%20tile%20factory%20production%20hand%20painted%20Iznik%20tiles%20workers%20professional%20bright%20clean%20interior&width=800&height=400&seq=tfc3&orientation=landscape",
    products: [
      {
        id: "tf3p1",
        name: "Hand-Painted Iznik Ceramic Tiles (20pcs)",
        samplePrice: 145,
        bulkPrice: 55,
        moq: 20,
        category: "Tiles",
        image: "https://readdy.ai/api/search-image?query=hand%20painted%20Iznik%20ceramic%20tiles%2020pcs%20Turkish%20traditional%20blue%20white%20pattern%20white%20background%20product%20photography%20premium&width=400&height=400&seq=tf3p1&orientation=squarish",
      },
      {
        id: "tf3p2",
        name: "Luxury Bathroom Ceramic Set",
        samplePrice: 280,
        bulkPrice: 105,
        moq: 5,
        category: "Ceramics",
        image: "https://readdy.ai/api/search-image?query=luxury%20bathroom%20ceramic%20set%20modern%20elegant%20white%20background%20product%20photography%20professional%20home%20decor%20Turkey&width=400&height=400&seq=tf3p2&orientation=squarish",
      },
      {
        id: "tf3p3",
        name: "Turkish Decorative Ceramic Vase Set",
        samplePrice: 65,
        bulkPrice: 24,
        moq: 15,
        category: "Home Decor",
        image: "https://readdy.ai/api/search-image?query=Turkish%20decorative%20ceramic%20vase%20set%20traditional%20pattern%20elegant%20white%20background%20product%20photography%20premium%20home%20decor&width=400&height=400&seq=tf3p3&orientation=squarish",
      },
    ],
  },
  {
    id: "tf4",
    name: "Gaziantep Spice & Food Export",
    city: "Gaziantep",
    established: 2009,
    employees: "100–200",
    verified: true,
    dropshipping: true,
    warehouseCountries: ["Turkey", "UAE", "Saudi Arabia", "UK", "Germany", "USA", "Australia"],
    rating: 4.9,
    responseRate: "97%",
    onTimeDelivery: "96%",
    productCount: 580,
    categories: ["Food & Beverage", "Spices", "Sweets"],
    description: "World-famous Gaziantep food exporter specializing in authentic Turkish spices, baklava, and gourmet foods. Supplying premium halal-certified products to global retailers and dropshippers from the culinary capital of Turkey.",
    logo: "https://readdy.ai/api/search-image?query=food%20spice%20company%20logo%20gold%20spice%20emblem%20white%20background%20Gaziantep%20Turkey%20food%20export%20corporate%20identity%20elegant&width=80&height=80&seq=tfl4&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Gaziantep%20Turkey%20food%20factory%20spices%20baklava%20production%20packaging%20workers%20professional%20bright%20clean%20modern%20interior&width=800&height=400&seq=tfc4&orientation=landscape",
    products: [
      {
        id: "tf4p1",
        name: "Authentic Gaziantep Baklava 1kg",
        samplePrice: 48,
        bulkPrice: 18,
        moq: 20,
        category: "Sweets",
        image: "https://readdy.ai/api/search-image?query=authentic%20Gaziantep%20baklava%201kg%20luxury%20gold%20box%20Turkish%20sweet%20white%20background%20product%20photography%20premium%20food&width=400&height=400&seq=tf4p1&orientation=squarish",
      },
      {
        id: "tf4p2",
        name: "Premium Turkish Spice Mix Set (12 jars)",
        samplePrice: 55,
        bulkPrice: 20,
        moq: 24,
        category: "Spices",
        image: "https://readdy.ai/api/search-image?query=premium%20Turkish%20spice%20mix%20set%2012%20jars%20colorful%20aromatic%20white%20background%20product%20photography%20professional%20food%20Gaziantep&width=400&height=400&seq=tf4p2&orientation=squarish",
      },
      {
        id: "tf4p3",
        name: "Turkish Pistachio Premium Box 500g",
        samplePrice: 42,
        bulkPrice: 16,
        moq: 30,
        category: "Food & Beverage",
        image: "https://readdy.ai/api/search-image?query=Turkish%20pistachio%20premium%20box%20500g%20luxury%20gold%20packaging%20white%20background%20product%20photography%20professional%20food%20snack&width=400&height=400&seq=tf4p3&orientation=squarish",
      },
    ],
  },
  {
    id: "tf5",
    name: "Izmir Leather & Accessories",
    city: "Izmir",
    established: 2011,
    employees: "100–200",
    verified: true,
    dropshipping: true,
    warehouseCountries: ["Turkey", "UAE", "UK", "Germany", "Italy", "USA"],
    rating: 4.8,
    responseRate: "95%",
    onTimeDelivery: "94%",
    productCount: 760,
    categories: ["Leather", "Bags", "Accessories"],
    description: "Premium leather goods manufacturer in Izmir producing handcrafted bags, wallets, belts, and accessories. Supplying luxury leather products to global fashion retailers and dropshippers with private label options.",
    logo: "https://readdy.ai/api/search-image?query=leather%20goods%20company%20logo%20gold%20leather%20emblem%20white%20background%20Izmir%20Turkey%20accessories%20manufacturing%20corporate%20identity%20elegant&width=80&height=80&seq=tfl5&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Izmir%20Turkey%20leather%20factory%20production%20handcrafted%20bags%20wallets%20accessories%20workers%20professional%20bright%20clean%20interior&width=800&height=400&seq=tfc5&orientation=landscape",
    products: [
      {
        id: "tf5p1",
        name: "Handcrafted Genuine Leather Tote Bag",
        samplePrice: 95,
        bulkPrice: 36,
        moq: 20,
        category: "Bags",
        image: "https://readdy.ai/api/search-image?query=handcrafted%20genuine%20leather%20tote%20bag%20luxury%20elegant%20white%20background%20product%20photography%20premium%20fashion%20Turkey%20Izmir&width=400&height=400&seq=tf5p1&orientation=squarish",
      },
      {
        id: "tf5p2",
        name: "Premium Leather Wallet Set (Men)",
        samplePrice: 45,
        bulkPrice: 16,
        moq: 30,
        category: "Accessories",
        image: "https://readdy.ai/api/search-image?query=premium%20leather%20wallet%20set%20men%20luxury%20elegant%20white%20background%20product%20photography%20professional%20accessories%20Turkey&width=400&height=400&seq=tf5p2&orientation=squarish",
      },
      {
        id: "tf5p3",
        name: "Genuine Leather Belt Collection (5pcs)",
        samplePrice: 68,
        bulkPrice: 25,
        moq: 20,
        category: "Leather",
        image: "https://readdy.ai/api/search-image?query=genuine%20leather%20belt%20collection%205pcs%20luxury%20elegant%20white%20background%20product%20photography%20professional%20accessories%20Turkey&width=400&height=400&seq=tf5p3&orientation=squarish",
      },
    ],
  },
  {
    id: "tf6",
    name: "Istanbul Smart Electronics Hub",
    city: "Istanbul",
    established: 2016,
    employees: "100–200",
    verified: true,
    dropshipping: true,
    warehouseCountries: ["Turkey", "UAE", "Saudi Arabia", "UK", "Germany", "USA", "Netherlands"],
    rating: 4.7,
    responseRate: "94%",
    onTimeDelivery: "93%",
    productCount: 640,
    categories: ["Electronics", "Smart Home", "Accessories"],
    description: "Modern electronics manufacturer in Istanbul producing smart home devices, consumer electronics, and tech accessories. Serving global markets with fast dropshipping from 7 warehouse locations across Europe and the Middle East.",
    logo: "https://readdy.ai/api/search-image?query=smart%20electronics%20company%20logo%20gold%20circuit%20emblem%20white%20background%20Istanbul%20Turkey%20technology%20corporate%20identity%20modern%20minimalist&width=80&height=80&seq=tfl6&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Istanbul%20Turkey%20smart%20electronics%20factory%20clean%20room%20production%20IoT%20devices%20consumer%20electronics%20professional%20bright%20modern&width=800&height=400&seq=tfc6&orientation=landscape",
    products: [
      {
        id: "tf6p1",
        name: "Smart LED Bulb Pack (10pcs) WiFi",
        samplePrice: 42,
        bulkPrice: 15,
        moq: 50,
        category: "Smart Home",
        image: "https://readdy.ai/api/search-image?query=smart%20LED%20bulb%20pack%2010pcs%20WiFi%20modern%20white%20background%20product%20photography%20professional%20tech%20home%20device%20electronics&width=400&height=400&seq=tf6p1&orientation=squarish",
      },
      {
        id: "tf6p2",
        name: "Portable Bluetooth Speaker Waterproof",
        samplePrice: 58,
        bulkPrice: 22,
        moq: 30,
        category: "Electronics",
        image: "https://readdy.ai/api/search-image?query=portable%20bluetooth%20speaker%20waterproof%20modern%20sleek%20design%20white%20background%20product%20photography%20professional%20tech%20electronics&width=400&height=400&seq=tf6p2&orientation=squarish",
      },
      {
        id: "tf6p3",
        name: "USB-C Fast Charging Hub 7-Port",
        samplePrice: 35,
        bulkPrice: 13,
        moq: 50,
        category: "Accessories",
        image: "https://readdy.ai/api/search-image?query=USB-C%20fast%20charging%20hub%207%20port%20modern%20sleek%20design%20white%20background%20product%20photography%20professional%20tech%20electronics%20accessories&width=400&height=400&seq=tf6p3&orientation=squarish",
      },
    ],
  },
];
